<template>
  <div>
    <h1>
      相关测评<span class="more check_more" @click="goAllTest()"
        >查看更多 &nbsp;>
      </span>
    </h1>
    <div class="content">
      <div v-for="(item, index) in tests" :key="index">
        <Card :item="item" @click="gotoDetail(item.id)"></Card>
      </div>
    </div>
    <van-button type="default" @click="goAllTest()" class="allbtn"
      >查看全部测评&nbsp;></van-button
    >
  </div>
</template>
<script>
import Card from "./Card";
export default {
  name: "RelatedTest",
  props: {
    tests: Array,
  },
  data() {
    return {};
  },
  method: {
    // 查看测评
    gotoDetail(id) {},
    // 查看全部测评
    goAllTest() {
      console.log("go all test");
      this.$router.push("./index");
    },
  },
  components: {
    Card,
  },
};
</script>
<style lang="less" scoped>
.more {
  float: right;
}
.allbtn {
  width: 80%;
  position: absolute;
  left: 10%;
  margin-bottom: 75px;
}
.check_more {
  color: #9b9b9b;
}
</style>
